import { SearchStaff } from "app/common/Model/SearchObject";
import { makeAutoObservable } from "mobx";
import {
  pagingStaff,
  saveOrUpdate,
  getStaffById,
  deleteStaff,
  getAllStaff,
  saveStaff,
  createUserWithStaff,
  syncStaffFromHRM,
} from "app/services/StaffService";
import { toast } from "react-toastify";
import { Staff } from "app/common/Model/Staff";
import { checkSearchObject } from "app/common/LocalFunction";
import moment from "moment";
import { downloadTemplateStaff, downloadTemplateStaffKPI, importStaffExcel, importStaffKPIExcel } from "app/services/ImportExcelService";

export default class StaffListStore {
  pageStaff = null;
  searchStaff = new SearchStaff({ tab: 0 });
  selectedStaff = null;
  openStaffPopup = false;
  openConfirmDeletePopup = false;
  staffId = null;
  listStaff = null;
  listScheduleStaff = [];
  selectedRowStaff = null;
  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowStaff = (row) => {
    this.selectedRowStaff = row;
  };

  setSearchStaff = (searchObj) => {
    this.searchStaff = searchObj;
  };

  setSelectedStaff = (staff) => {
    this.selectedStaff = staff;
  };

  pagingStaff = () => {
    pagingStaff(this.searchStaff)
      .then(({ data }) => (this.pageStaff = data))
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu không thành công");
      });
  };

  getStaffById = async (staffId) => {
    return await getStaffById(staffId)
      .then(({ data }) => {
        this.selectedStaff = data;
        // this.openStaffPopup = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin nhân viên không thành công");
      });
  };
  getAllStaff = async () => {
    return await getAllStaff()
      .then(({ data }) => {
        this.listStaff = data?.content;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin nhân viên không thành công");
      });
  };

  setStaffId = (staffId) => {
    this.staffId = staffId;
    this.getStaffById(staffId);
  };

  handleOpenCreateUpdatePopup = (staffId) => {
    if (staffId) {
      this.getStaffById(staffId).then(() => {
        this.openStaffPopup = true;
      });
    } else {
      this.selectedStaff = new Staff();
      this.openStaffPopup = true;
    }
  };

  handleChangeFormSearch = (searchStaff) => {
    let newSearchStaff = this.searchStaff;
    if ("tab" in searchStaff) {
      newSearchStaff.tab = searchStaff?.tab;
      newSearchStaff.keyword = searchStaff?.keyword;
      newSearchStaff.pageIndex = 1;
      newSearchStaff.departmentId = searchStaff?.department?.id;
      newSearchStaff.deptIdOfStaffInRoom = searchStaff?.deptIdOfStaffInRoom?.id;
      newSearchStaff.roomId = searchStaff?.room?.id;
      newSearchStaff.positionCode = searchStaff?.position?.code;
      newSearchStaff.roleIds = searchStaff?.roleIds?.id;
      newSearchStaff.roleIds = searchStaff?.roleIds?.map(role => role?.id);
      newSearchStaff.listStaffGroupId = searchStaff?.listStaffGroupId?.map(role => role?.id);
    } else {
      newSearchStaff = checkSearchObject(newSearchStaff, searchStaff);
    }

    this.searchStaff = newSearchStaff;
    this.pagingStaff();
  };

  saveOrUpdateStaff = async (staff, notReset) => {
    return await saveOrUpdate(staff)
      .then(({ data }) => {
        if (!notReset) {
          this.selectedStaff = null;
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          const staffId = urlParams.get("staffId");
          if (staffId) {
            this.getStaffById(staffId);
          }
        }
        console.log("data", data);

        if (data.responseStatus === 1) {
          toast.success("Lưu thông tin nhân viên thành công!");
          this.pagingStaff();
          this.handleClosePopup();
        } else if (data.responseStatus == -1) {
          toast.warning("Tên tài khoản đã tồn tại.Vui lòng chọn tên khác!");
        } else {
          toast.warn(data.message);
          this.pagingStaff();
          this.handleClosePopup();
        }
      })
      .catch((error) => {
        console.error(error);
        console.error(error?.response);
        toast.error("Lưu thông tin nhân viên có lỗi");
      });
  };
  saveStaff = async (staff, notReset) => {
    return await saveStaff(staff)
      .then((data) => {
        if (!notReset) {
          this.selectedStaff = null;
        }
        if (data.responseStatus === 1) {
          toast.success("Lưu thông tin nhân viên thành công!");
          this.pagingStaff();
          this.handleClosePopup();
        } else if (data.responseStatus == "-1") {
          toast.warning("Tên tài khoản đã tồn tại.Vui lòng chọn tên khác!");
        } else {
          toast.warn(data.message);
          this.pagingStaff();
          this.handleClosePopup();
        }
      })
      .catch((error) => {
        console.error(error);
        console.error(error?.response);
        toast.error("Lưu thông tin nhân viên có lỗi");
      });
  };

  createUserWithStaff = async (account) => {
    try {
    } catch (error) { }
  };

  handleOpenConfirmDeletePopup = (staff) => {
    this.selectedStaff = staff;
    this.openConfirmDeletePopup = true;
  };

  handleConfirmDelete = () => {
    return deleteStaff(this?.selectedStaff?.id)
      .then(() => {
        toast.success("Xóa nhân viên thành công!");
        this.pagingStaff();
        this.handleClosePopup();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa nhân viên có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openStaffPopup = false;
    this.openConfirmDeletePopup = false;
    this.openConfirmSyncStaffHRMPopup = false;
  };

  resetStore = () => {
    this.searchStaff = new SearchStaff();
    this.pageStaff = null;
    this.selectedStaff = null;
    this.openStaffPopup = false;
    this.openConfirmDeletePopup = false;
    this.openConfirmSyncStaffHRMPopup = false;
  };

  // openConfirmSyncStaffHRMPopup = false;

  // handleOpenConfirmSyncStaffHRMPopup = () => {
  //   this.openConfirmSyncStaffHRMPopup = true;
  // };

  openSyncStaffHRM = false;

  handleOpenSyncStaffHRM = () => {
    this.openSyncStaffHRM = true
  }

  handleCloseSyncStaffHRM = () => {
    this.openSyncStaffHRM = false
  }


  handleConfirmSyncStaffHRM = async (obj, { setSubmitting }) => {
    setSubmitting(true);
    toast.info("Đồng bộ nhân viên với HRM đang được xử lý, vui lòng đợi.", {
      autoClose: 6868,
    });

    try {
      const { data: response } = await syncStaffFromHRM(obj);
      if (response) {
        this.openConfirmSyncStaffHRMPopup = false;
        toast.success("Đồng bộ nhân viên với HRM thành công");
        this.openSyncStore = false;
        this.pagingStaff();
        return response;
      }
    } catch (error) {
      toast.dismiss();
      console.error(error);
      toast.error("Đồng bộ nhân viên với HRM có lỗi");
    } finally {
      setSubmitting(false);
    }
  };

  handleImportTemplateStaff = (file, importStaffType = "staff") => {
    let importPromise;

    if (importStaffType === "staffDepartmentKPI") {
      importPromise = importStaffKPIExcel(file); // hàm import KPI
    } else if (importStaffType === "staff") {
      importPromise = importStaffExcel(file); // hàm import nhân viên
    }

    importPromise
      .then(({ data }) => {
        toast.success(
          importStaffType === "staffDepartmentKPI"
            ? "Tải file KPI nhân viên theo cơ sở thành công!"
            : "Tải file nhân viên thành công!"
        );
        this.getAllStaff();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };


  handleDownloadTemplateStaff = async (downloadStaffType = "staff") => {
    try {
      let res;
      let fileNamePrefix = "";

      if (downloadStaffType === "staffDepartmentKPI") {
        res = await downloadTemplateStaffKPI(); // hàm download KPI
        fileNamePrefix = "MAU_KPI_NHAN_VIEN_THEO_CO_SO";
      } else {
        res = await downloadTemplateStaff(); // hàm download nhân viên
        fileNamePrefix = "MAU_NHAN_VIEN";
      }

      const url = window.URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        fileNamePrefix + "_" + moment(new Date()).format("DDMMYYYY-HHmm") + ".xlsx"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Lỗi khi tải file:", error);
    }
  };


  // handleConfirmSyncStaffHRM = async () => {
  //   toast.info("Đồng bộ nhân viên với HRM đang được xử lý, vui lòng đợi.", {
  //     autoClose: 6868,
  //   });

  //   try {
  //     const { data: response } = await syncStaffFromHRM();
  //     if (response) {
  //       this.openConfirmSyncStaffHRMPopup = false;
  //       toast.success("Đồng bộ nhân viên với HRM thành công");

  //       this.pagingStaff();

  //       return response;
  //     }
  //   } catch (error) {
  //     toast.dismiss();
  //     console.error(error);
  //     toast.error("Đồng bộ nhân viên với HRM có lỗi");
  //   } finally {
  //   }
  // };
}
